import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { AppRoute } from '@/lib/url/urls'

type ModuleAccessRouteProps = {
  hasAccess: boolean
  isLoading: boolean
  children: ReactNode
}

export const ModuleAccessRoute = ({ hasAccess, isLoading, children }: ModuleAccessRouteProps) => {
  if (isLoading) return null
  if (!hasAccess) return <Navigate to={AppRoute.OVERVIEW} replace />

  return <>{children}</>
}
